/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { BridgeBSC } from "../BridgeBSC";

export class BridgeBSC__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _tokenAddress: string,
    _operator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BridgeBSC> {
    return super.deploy(
      _tokenAddress,
      _operator,
      overrides || {}
    ) as Promise<BridgeBSC>;
  }
  getDeployTransaction(
    _tokenAddress: string,
    _operator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _tokenAddress,
      _operator,
      overrides || {}
    );
  }
  attach(address: string): BridgeBSC {
    return super.attach(address) as BridgeBSC;
  }
  connect(signer: Signer): BridgeBSC__factory {
    return super.connect(signer) as BridgeBSC__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BridgeBSC {
    return new Contract(address, _abi, signerOrProvider) as BridgeBSC;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address",
      },
      {
        internalType: "address payable",
        name: "_operator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    name: "BridgeRequestToPolygon",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "bridgeRequestsToPolygon",
    outputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "burnAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_operator",
        type: "address",
      },
    ],
    name: "changeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_operatorFee",
        type: "uint256",
      },
    ],
    name: "changeOperatorFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "makeBridgeRequestToPolygon",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxOperatorFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "operator",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "operatorFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "requestToPolygonNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
